import React, { useState, useEffect } from "react";
import { Modal, Select, Input, Form, Button } from "antd";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import configureAppStore from "../../redux/store";
import { callApi } from "../../api/apiCaller";

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      if (recordData) {
        form.setFieldsValue({
          name: recordData.name,
          email: recordData.email,
          number: recordData.number,
          address: recordData.address,
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, recordData, form]);

  const token = configureAppStore.getState().userDataSlice.token;

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const requestBody = {
          name: values.name,
          email: values.email,
          number: values.number,
          address: values.address,
          role: "Client",
        };
        if (!recordData) {
          requestBody.password = values.password;
        }
        const getRes = (res) => {
          if (res.status === 403) {
            RedNotify("you don't have permission to perform this action");
            toggleModal();
          } else if (res.status === 200) {
            GreenNotify(
              recordData
                ? "User updated successfully."
                : "Trainer created successfully."
            );
            toggleModal();
          } else {
            RedNotify("An error occurred. Please try again later.");
          }
        };

        const apiCall = recordData
          ? callApi(
              "PATCH",
              `${routes.updateClient}/${recordData._id}`,
              requestBody,
              setIsLoading,
              getRes
            )
          : callApi(
              "POST",
              `${routes.createClient}`,
              requestBody,
              setIsLoading,
              getRes
            );

        apiCall.catch((error) => {
          console.error("API call error", error);
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        });
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
        RedNotify("Please ensure all fields are filled out correctly.");
      });
  };

  return (
    <Modal
      title={recordData ? "Update Client" : "Create Client"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={isLoading}
        >
          {recordData ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter name" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please enter email" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Number"
          name="number"
          rules={[{ required: true, message: "Please enter number" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Address"
          name="address"
          rules={[{ required: true, message: "Please enter the title" }]}
        >
          <Input />
        </Form.Item>
        {!recordData && (
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter password" }]}
          >
            <Input.Password />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default AddVideo;
